module.exports = __webpack_public_path__ + "img/barlogo.cdc8e3a9.png";